import { ReactNode } from 'react';
import { Text, Box, Flex, Icon, Stack } from '@pairy/pds-react';

import { Nullable } from '@/types/helper';
import { formatKoreanPhoneNumber } from '@/utils/formatPhone';

interface Props {
  name: Nullable<string>;
  email: Nullable<string>;
  company?: Nullable<string>;
  phone?: Nullable<string>;
  onClick?: () => void;
  disabled?: boolean;
  /** 이름 옆에 덧붙일 표기 (예: 이메일 캠페인 수신자 선택의 '수신거부' 배지) */
  badge?: ReactNode;
}

const ClientBox = ({
  name,
  email,
  company,
  phone,
  onClick,
  disabled = false,
  badge,
}: Props) => {
  const displayName =
    name ||
    company ||
    (phone ? formatKoreanPhoneNumber(phone) : null) ||
    email ||
    '(이름 없음)';

  return (
    <Box backgroundColor={disabled ? 'zinc_200' : 'white'}>
      <Flex alignItems="center" justifyContent="space-between">
        <div>
          <Stack direction="row" gap={6} alignItems="center" marginBottom={4}>
            <Text
              as="p"
              variant="md-semibold"
              color={disabled ? 'zinc_400' : 'black'}
            >
              {displayName}
            </Text>
            {badge}
          </Stack>
          <Text
            as="p"
            variant="sm-regular"
            color={disabled ? 'zinc_400' : 'black'}
          >
            {email}
          </Text>
        </div>
        {disabled || (
          <button onClick={onClick}>
            <Icon icon="ph:plus" size={17} color="black" />
          </button>
        )}
      </Flex>
    </Box>
  );
};

export default ClientBox;
